export default __webpack_public_path__ + "static/media/slalom.faf4d1d6.png";